const addHttpsToAnchorTag = (text: string) => {
  const regex = /href="(?!https?:\/\/)([^"]+)"/g;
  return text.replace(regex, 'href="https://$1"');
};

export default addHttpsToAnchorTag;
